import React, { Component } from 'react'
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, FormGroup, Input, Button, Alert } from 'reactstrap'
import {
  register,
  login
} from '../../actions/appealActions'
import {
  checkAdminTokenRedirect
} from '../../actions/adminActions'
import Form from '../../modules/Form'
import { withRouter } from 'react-router'
import Cookies from 'universal-cookie'
import PropTypes from 'prop-types'

const cookies = new Cookies()

class App extends Component {
  componentDidMount () {
    // check for admin token
    if (cookies.get('ps_admin_access_token')) {
      this.props.checkAdminTokenRedirect(cookies.get('ps_admin_access_token'))
    }
    // check if cookie exists
    if (cookies.get('appealID')) {
      this.props.checkToken(cookies.get('appealID'))
    }
  }

  render () {
    return (

      <div>
        <Container>
          <Row>
            <Col className='text-center'>
              <p>Welcome. To get started, complete your details below. You can save and return to your appeal at anytime.</p>
            </Col>
          </Row>
          <Row>
            <Col xs={{ size: 10, offset: 1 }} sm={{ size: 8, offset: 2 }} className='form-container'>
              {
                this.props.appeal.register_error
                  ? <Alert color='danger'>
                    {this.props.appeal.register_error}
                  </Alert>
                  : null
              }

              <Form submit={this.props.register} >
                <h2>Register New Appeal</h2>
                <FormGroup>
                  <Input type='text' name='pcn' id={'pcn'} required placeholder='PCN Number' />
                  <div className='invalid-feedback' />
                </FormGroup>
                <FormGroup>
                  <Input type='text' className='input-uppercase' name='reg' id={'reg'} required placeholder='Vehicle Registration' maxLength='8' />
                  <div className='invalid-feedback' />
                </FormGroup>
                <FormGroup>
                  <Input type='date' name='date' id={'date'} required placeholder='Date of issue' />
                  <div className='invalid-feedback' />
                </FormGroup>
                <FormGroup>
                  <Input type='email' name='email' id={'email'} required placeholder='Email' />
                  <div className='invalid-feedback' />
                </FormGroup>
                <Button color='primary' disabled={this.props.appeal.register_loading}>Submit <span className='spinning' /></Button>
              </Form>

            </Col>
          </Row>
          <Row>
            <Col xs={{ size: 10, offset: 1 }} sm={{ size: 8, offset: 2 }} className='form-container'>
              {
                this.props.appeal.login_error
                  ? <Alert color='danger'>
                    {this.props.appeal.login_error}
                  </Alert>
                  : null
              }
              <Form submit={this.props.login} >
                <h2>Login</h2>
                <FormGroup>
                  <Input type='text' name='pcn' id={'pcn'} required placeholder='PCN Number' />
                  <div className='invalid-feedback' />
                </FormGroup>
                <FormGroup>
                  <Input type='email' name='email' id={'email'} required placeholder='Email' />
                  <div className='invalid-feedback' />
                </FormGroup>
                <Button color='primary' disabled={this.props.appeal.login_loading}>Login <span className='spinning' /></Button>
              </Form>
            </Col>
          </Row>
        </Container>

      </div>
    )
  }
};

App.propTypes = {
  checkToken: PropTypes.func,
  checkAdminTokenRedirect: PropTypes.func,
  appeal: PropTypes.object,
  register: PropTypes.func,
  login: PropTypes.func
}

const mapStateToProps = ({ appeal }) => ({
  appeal
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      register,
      login,
      changePage: () => push('/about-us'),
      checkToken: (id) => push(`/appeal/${id}`),
      checkAdminTokenRedirect
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App))



// WEBPACK FOOTER //
// ./src/containers/home/index.jsx